var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n    <div class="top">\n        <h4 class="symbol">'+
((__t=( quote.symbol ))==null?'':__t)+
'</h4>\n        <div>\n            <img src="'+
((__t=( quote.base_currency_img ))==null?'':__t)+
'">\n            <img src="'+
((__t=( quote.quote_currency_img ))==null?'':__t)+
'">\n        </div>\n    </div>\n    <div class="bottom">\n        <dl>\n            <dt>Bid</dt>\n            <dd class="bid">'+
((__t=( quote.bid ))==null?'':__t)+
'</dd>\n        </dl>\n        <p class="spread">'+
((__t=( quote.spread ))==null?'':__t)+
'</p>\n        <dl>\n            <dt>Ask</dt>\n            <dd class="ask">'+
((__t=( quote.ask ))==null?'':__t)+
'</dd>\n        </dl>\n    </div>\n</li>';
}
return __p;
};
